export default "__VITE_ASSET__BBsbfyvS__"